export const minutesToMilliseconds = (minutes: number) => 1000 * 60 * minutes
